import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  ShopOutlined,
  UploadOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Space,
  Switch,
  Upload,
  message,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { uploadFile } from "react-s3";
// import Logo from "../../assets/images/logo.svg";
import notfound from "../../assets/images/not_found.png";
import Notification from "../../assets/images/notification.svg";
import Notification1 from "../../assets/images/face-1.jpg";
import Notification2 from "../../assets/images/face-1.jpg";
import Notification3 from "../../assets/images/face-1.jpg";
import DeleteModal from "../../components/DeleteModal";
import { s3Config } from "../../config/s3Config";
import apiPath from "../../constants/apiPath";
import { AuthContext } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { useAppContext } from "../../context/AppContext";

const { confirm } = Modal;
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

const currency = ["AED", "INR"];

function Header({ name: sectionHeading, onPress, setToggle }) {
  useEffect(() => window.scrollTo(0, 0));
  const [visible, setVisible] = useState(false);
  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [appSetting, setAppSetting] = useState({});
  const [appSettingSelected, setAppSettingSelected] = useState();
  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const [countries, setCountries] = useState([]);
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(false);
  const { logout } = useContext(AuthContext);
  const { setCountry, country } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [businessVisible, setBusinessVisible] = useState(false);

  // useEffect(() => {
  //   getCountry();
  // }, []);

  // const getCountry = () => {
  //   request({
  //     url: `/country`,
  //     method: "GET",
  //     onSuccess: ({ data, status }) => {
  //       console.log(data, "Country");
  //       if (data) {
  //         setCountries(data);
  //         data.length &&
  //           setCountry((prev) => ({ ...prev, country_id: data[0]._id }));
  //       }
  //     },
  //   });
  // };

  const notificationitems = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>Notifications</h5>
          </div>
          <div className="notification-inner">
            <div className="single-notification">
              <div className="notification-img">
                <img src={Notification1} />
              </div>
              <div className="notification-cont">
                <p>
                  <span> new booking</span>
                </p>
              </div>
            </div>
            <div className="single-notification">
              <div className="notification-img">
                <img src={Notification2} />
              </div>
              <div className="notification-cont">
                <p>
                  new booking
                  {/* Haylie Western ordered{" "}
                  <span>American Dream Pizza(12 Inch)</span> from{" "}
                  <span>Restaurant Name 1</span> */}
                </p>
              </div>
            </div>
            <div className="single-notification">
              <div className="notification-img">
                <img src={Notification3} />
              </div>
              <div className="notification-cont">
                <p>
                  new appointment
                  {/* Driver <span>Frank Murlo</span> sends a withdrawal request of
                  amount <span>AED 700</span> */}
                </p>
              </div>
            </div>
          </div>
          {/* <div className="viewAll_notification">
            <Button
              onClick={() => navigate("/notification")}
              className="btnStyle btn_primary"
            >
              View All
            </Button>
          </div> */}
        </div>
      ),
    },
  ];

  const items = [
    { label: "Edit Profile", key: "1", icon: <UserOutlined /> },
    { label: "Change Password", key: "2", icon: <KeyOutlined /> },
    { label: "Logout", key: "3", icon: <LogoutOutlined /> },
  ];

  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  const handleMenuClick = (e) => {
    setIsOpen(false);
    if (e.key == 2) {
      setVisible(true);
    }
    if (e.key == 1) {
      setProfileVisible(true);
    }
    if (e.key == 3) {
      showDeleteConfirm();
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleCreate = (values) => {
    onCreate(values);
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values;
    const payload = {};
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    setLoading(true);
    payload.new_password = new_password;
    payload.old_password = old_password;
    request({
      url: apiPath.changePassword,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setVisible(false);
          logout();
          ShowToast("Logout successful", Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    // setBreadcrumb(sectionHeading?.split("/") ?? []);
  }, [sectionHeading]);

  useEffect(() => {
    request({
      url: apiPath.profile,
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data.user);
        setSelected(data.data.user);
      },
    });
    // request({
    //   url: apiPath.getAppSetting,
    //   method: "GET",
    //   onSuccess: (data) => {
    //     setAppSetting(data.data);
    //     setAppSettingSelected(data.data);
    //   },
    // });
  }, [refresh]);
  return (
    <>
      <Row gutter={[24, 0]} className="justify-content-between mx-0">
        <Col
          span={24}
          xs={18}
          md={24}
          lg={12}
          sm={5}
          className="SectionMain px-0"
        >
          <div className="d-none d-lg-block">
            <div className="section-headding">
              <div className="d-flex align-items-center">
                <Button
                  type="link"
                  className="sidebar-toggler ps-0 d-none d-lg-block"
                  onClick={() => setToggle()}
                >
                  {toggler}
                </Button>
                <h6>Welcome, {profile?.name || profile?.name || "Admin"}!</h6>
              </div>
            </div>
          </div>
          <div className="tabLogo d-lg-none">
            <img className="w-100" src="" />
          </div>
        </Col>
        <Col span={24} xs={24} sm={24} lg={12} className="header-control px-0">
          <Button
            type="link"
            className="sidebar-toggler ps-0"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          {/* <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <Dropdown
                menu={{ items: notificationitems }}
                trigger={["click"]}
                className="notification-box"
              >
                <Button>
                  <img src={Notification} />
                  <span className="active_notification"></span>
                </Button>
              </Dropdown>
            </div>
          </div> */}
          <div className="profileDropdownMain">
            <Dropdown
              open={isOpen}
              onOpenChange={(open) => setIsOpen(open)}
              className="edit-box"
              menu={menuProps}
              trigger={["click"]}
            >
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">
                  {/* <div className="userImg">
                    <Image
                      src={profile ? profile.image : notfound}
                      preview={false}
                    />
                  </div> */}
                  <div className="d-none d-xl-block">
                    <div className="userName">
                      {profile ? profile?.name : "Administrator"}
                      <DownOutlined />
                    </div>
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
        </Col>
      </Row>

      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to Logout the Application?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            logout();
            // Display success message here
            ShowToast("Logout successful", Severty.SUCCESS);
          }}
        />
      )}

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {appSettingVisible && (
        <AppSetting
          show={appSettingVisible}
          hide={() => {
            setAppSettingVisible(false);
          }}
          data={appSettingSelected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          handleCreate={handleCreate}
          hide={() => {
            setVisible(false);
          }}
        />
      )}

      {businessVisible && (
        <BusinessProfileSetup
          show={businessVisible}
          hide={() => setBusinessVisible(false)}
          data={profile?.business || {}}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    "image/gif",
  ];

  const beforeUpload = (file) => {
    if (!FileType.includes(file.type)) {
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!data) return;

    // Reset form and set values
    form.resetFields();
    form.setFieldsValue({
      name: data.name,
      email: data.email,
    });

    // Set image if exists
    if (data.profile_image) {
      setImage(data.profile_image);
      setFile([
        {
          uid: "-1",
          name: "profile-image",
          status: "done",
          url: data.profile_image,
        },
      ]);
    } else {
      setImage(null);
      setFile([]);
    }
  }, [data, form]);

  const handleChange = async (event) => {
    const { file } = event;

    // Validate file before upload
    if (!beforeUpload(file)) {
      return;
    }

    try {
      setLoading(true);
      const result = await uploadFile(file, s3Config("profile"));
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: result.location,
        thumbUrl: result.location,
      };
      setFile([fileData]);
      setImage(result.location);
    } catch (err) {
      console.error(err);
      message.error("Failed to upload image");
    } finally {
      setLoading(false);
    }
  };

  const onEditProfile = async (values) => {
    const { email, name } = values;

    // Don't require image for profile update
    const payload = {
      email: email,
      name: name,
    };

    // Only include image if a new one was uploaded
    if (file.length > 0 && file[0].url) {
      payload.image = file[0].url;
    }

    setLoading(true);

    try {
      const response = await request({
        url: apiPath.updateProfile,
        method: "PUT",
        data: payload,
      });

      if (response?.status) {
        ShowToast(response?.message, Severty.SUCCESS);

        // Close modal first
        hide();

        // Refresh parent component
        if (refresh) {
          refresh();
        }

        // Don't navigate to login after profile update
        // navigate("/login"); // Remove this line
      } else {
        ShowToast(response?.message, Severty.ERROR);
      }
    } catch (error) {
      ShowToast(
        error.response?.data?.message || "Update failed",
        Severty.ERROR
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = () => {
    setFile([]);
    setImage(null);
  };

  return (
    <Modal
      open={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      onCancel={hide}
      footer={null} // Remove default footer since we have our own button
      destroyOnClose // This helps with the ResizeObserver issue
      forceRender // This can help with modal rendering issues
    >
      <h4 className="modal_title_cls">Edit Profile</h4>
      <Form
        id="create"
        form={form}
        onFinish={onEditProfile}
        layout="vertical"
        disabled={loading}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
              normalize={(value) => value.trimStart()}
              rules={[
                { required: true, message: "Please enter the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
              ]}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email Address"
              name="email"
              normalize={(value) => value.trimStart()}
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                { required: true, message: "Please enter the email!" },
              ]}
            >
              <Input placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          {/* Optional: Uncomment if you want image upload */}
          {/* <Col span={24}>
            <Form.Item
              className=""
              label="Upload Profile"
              name="image"
            >
              <Upload
                listType="picture"
                maxCount={1}
                beforeUpload={beforeUpload}
                customRequest={handleChange}
                onRemove={handleRemove}
                fileList={file}
                accept="image/*"
              >
                {file.length >= 1 ? null : (
                  <Button icon={<UploadOutlined />} loading={loading}>
                    Upload
                  </Button>
                )}
              </Upload>

              {image && (
                <div className="mt-3">
                  <Image width={100} src={image} preview={false} />
                </div>
              )}
            </Form.Item>
          </Col> */}
        </Row>

        {/* Custom footer buttons */}
        <div className="modal_footer">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Update Profile
          </Button>
          <Button    type="primary" onClick={hide} disabled={loading}>
            Cancel
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
const BusinessProfileSetup = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(data?.logo || null);
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) form.setFieldsValue(data);
  }, [data]);

  const handleLogoUpload = (file) => {
    // upload logic similar to profile image
    setLogoFile(file);
    // Assume upload returns URL
    uploadFile(file, s3Config("business-logo")).then((res) =>
      setLogoUrl(res.location)
    );
  };

  const onSubmit = (values) => {
    if (!logoUrl) return ShowToast("Please upload logo", Severty.ERROR);

    const payload = {
      ...values,
      logo: logoUrl,
    };

    setLoading(true);
    request({
      url: "/vendor/business/update", // backend API
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast("Business profile updated", Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err?.response?.data?.message || "Error", Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      okButtonProps={{ form: "businessForm", htmlType: "submit", loading }}
    >
      <h4>Setup Business Profile</h4>
      <Form form={form} id="businessForm" onFinish={onSubmit} layout="vertical">
        <Form.Item
          label="Business Name"
          name="businessName"
          rules={[{ required: true }]}
        >
          <Input placeholder="Enter Business Name" />
        </Form.Item>

        <Form.Item label="Business Logo">
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={() => false}
            customRequest={({ file }) => handleLogoUpload(file)}
          >
            <Button icon={<UploadOutlined />}>Upload Logo</Button>
          </Upload>
          {logoUrl && <img src={logoUrl} width={100} className="mt-2" />}
        </Form.Item>

        <Form.Item label="Public Page Link" name="publicLink">
          <Input placeholder="Unique public link" />
        </Form.Item>

        <Form.Item
          label="Auto Accept Appointment"
          name="autoAccept"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          label="Allow Multiple Bookings per Slot"
          name="allowMultiple"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        {/* Add availability calendar component here later */}
      </Form>
    </Modal>
  );
};

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  const onAppSetting = (values) => {
    setLoading(true);
    request({
      url: apiPath.updateAppSetting,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      width={1200}
      open={show}
      // title={`${data ? "Update App Setting" : ""}`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Update App Setting</h4>
      <Form id="create" form={form} onFinish={onAppSetting} layout="vertical">
        <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
          <Col span={24} md={12}>
            <Card className="card-profile-head" title="Android Details">
              <Col span={24}>
                <Form.Item
                  label="App Store URL"
                  name="app_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the app store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Version"
                  name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Share Content"
                  name="android_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

          <Col span={24} md={12}>
            <Card title="IOS Details">
              <Col span={24} className="">
                <Form.Item
                  label="Play Store URL"
                  name="play_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the play store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Version"
                  name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Share Content"
                  name="ios_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, handleCreate }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={show}
      // title="Change password"
      okText="Ok"
      onCancel={hide}
      //onOk={handleCreate}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        //loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Change Password</h4>
      <Form id="create" form={form} onFinish={handleCreate} layout="vertical">
        {/* Old Password */}
        <Form.Item
          label="Old Password"
          name="old_password"
          normalize={(value) => value.trimStart()}
          hasFeedback
          rules={[{ required: true, message: "Old password is required." }]}
        >
          <Input.Password
            placeholder="Enter your old password"
            maxLength={40}
          />
        </Form.Item>

        {/* New Password */}
        <Form.Item
          label="New Password"
          name="new_password"
          dependencies={["old_password"]}
          normalize={(value) => value.trimStart()}
          hasFeedback
          rules={[
            { required: true, message: "New password is required." },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*]).{8,}$/,
              message:
                "Must be at least 8 characters with uppercase, lowercase, number, and special character.",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("old_password") !== value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("New password must be different from old password.")
                );
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Enter your new password"
            maxLength={40}
          />
        </Form.Item>

        {/* Confirm New Password */}
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          normalize={(value) => value.trimStart()}
          hasFeedback
          rules={[
            { required: true, message: "Please confirm your new password." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match."));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Confirm your new password"
            maxLength={40}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Header;
